import { graphql } from "react-apollo";
import { createOptions } from "../../utils/createOptions";
import { AllTaskTypes } from "../../queries/AllTaskProperties";

const withTaskTypeOptions = (value1 = "name", value2 = "description") =>
  graphql(AllTaskTypes, {
    options: () => ({ fetchPolicy: "cache-first" }),
    props: ({ data: { allTaskTypes, loading, error } }) => ({
      error,
      typesLoading: loading,
      taskTypeOptions: allTaskTypes ? createOptions(allTaskTypes, value1, value2) : [],
    }),
  });

export default withTaskTypeOptions;



// WEBPACK FOOTER //
// ./src/component/TasksListComponents/withTaskTypesOptions.js